import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(24);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const ScanTimeIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <mask
        id="scanTimeIcon0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M0 0H24V24H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#scanTimeIcon0)">
        <circle cx="12" cy="12" r="12" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8797 10.2034C13.5432 10.5289 14 11.2111 14 12C14 12.7491 13.5882 13.402 12.9785 13.7447C12.9133 14.8647 12.6968 16 12.0051 16C11.3143 16 11.0954 14.8673 11.0283 13.7485C10.4149 13.4069 10 12.7519 10 12C10 11.2088 10.4595 10.5249 11.1261 10.2005C11.3942 7.02923 12.0051 1 12.0051 1C12.0051 1 12.6132 7.03286 12.8797 10.2034Z"
          fill="black"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(ScanTimeIcon);
